import React from 'react';
import {
  DataTableV2,
  DataTableHeadV2,
  DataTableHeadCellV2,
  DataTableRowV2,
  DataTableCellV2,
  DataTableBodyV2,
  AccentBar,
} from '@americanexpress/dls-react';
import PropTypes from 'prop-types';
import * as LABELCONST from '../../constants/constFileLabelsVendor';

// TODO: Add mappings and remove hardcoded string after integrating APIs
const ReviewPage = (props) => {
  const { formData } = props;

  return (
    <div className="margin-responsive">
      <div>
        <h1>{LABELCONST.REVIEW}</h1>
        <div className="new-line" />
        <span>
          Our records show the following contact information for you. If any of
          the information is wrong. Please update it.
        </span>
        <div className="new-line" />
        <div className="new-line" />
      </div>
      <AccentBar />
      <div className="new-line" />
      <div className="new-line" />
      <DataTableV2 id="table-base-instance" striped={true}>
        <DataTableHeadV2>
          <DataTableRowV2>
            <DataTableHeadCellV2 className="table-gap">
              Field
            </DataTableHeadCellV2>
            <DataTableHeadCellV2>Value</DataTableHeadCellV2>
          </DataTableRowV2>
        </DataTableHeadV2>
        <DataTableBodyV2>
          <DataTableRowV2>
            <DataTableCellV2>First Name</DataTableCellV2>
            <DataTableCellV2>
              {formData.supplierFirstName ?? ''}
            </DataTableCellV2>
          </DataTableRowV2>
          <DataTableRowV2>
            <DataTableCellV2>Last Name</DataTableCellV2>
            <DataTableCellV2>{formData.supplierLastName ?? ''}</DataTableCellV2>
          </DataTableRowV2>
          <DataTableRowV2>
            <DataTableCellV2>Phone</DataTableCellV2>
            <DataTableCellV2>{formData.supplierPhoneNo ?? ''}</DataTableCellV2>
          </DataTableRowV2>
          <DataTableRowV2>
            <DataTableCellV2>Email</DataTableCellV2>
            <DataTableCellV2>{formData.supplierEmail ?? ''}</DataTableCellV2>
          </DataTableRowV2>
        </DataTableBodyV2>
      </DataTableV2>
    </div>
  );
};

ReviewPage.propTypes = {
  formData: PropTypes.func,
};

export default ReviewPage;
